export function getGtagMeasurementId(isStaging) {
    const measurementIdElement = document.querySelector('[name="ga-measurementId"]');
    let measurement_id = measurementIdElement ? measurementIdElement.getAttribute("content") : "";
    if (isStaging) {
        const measurementIdElementStaging = document.querySelector('[name="ga-measurementId-staging"]');
        measurement_id = measurementIdElementStaging ? measurementIdElementStaging.getAttribute("content") : "";
    }
    return measurement_id;
}